import {Pipe} from '@angular/core';
import {Utilities} from '../utilities/utilities.model';

@Pipe({
	name: 'removeSpaces'
})

export class RemoveSpacesPipe {
	transform(value): string | null {
		return (!Utilities.isVoid(value) ? value.replace('//g', '') : null);
	}
}